import { FilterTypeModel } from './abstract-filter-type.model';
import { FilterTypesEnum } from '../enums/filters-types.enum';
import { DuplicatesStatusEnum } from '../enums/duplicates-status.enum';
import { ChipModel } from '../../Forms/models/chip.model';

export class FilterTypeDuplicatesModel extends FilterTypeModel<DuplicatesStatusEnum> {
    readonly key: FilterTypesEnum = FilterTypesEnum.duplicates;
    showGroup: boolean;

    protected value: DuplicatesStatusEnum;
    protected currentValue: DuplicatesStatusEnum;

    constructor(
        id: string,
        label: string,
        showGroup: boolean,
        value?: DuplicatesStatusEnum,
        section?: string
    ) {
        super(id, label, section);

        this.showGroup = showGroup;
        this.setValue(value || DuplicatesStatusEnum.show);
    }

    /**
     * Sets the active value for a filter
     * @param value
     */
    setValue(value: DuplicatesStatusEnum): void {
        this.value = value;
        if (this.value === DuplicatesStatusEnum.hide) {
            this.chips = [
                {
                    label: 'Common.filter.duplicates.hidden',
                    labelArgs: {
                        name: this.label
                    }
                }
            ];
        } else {
            this.chips = [];
        }
        this.cancelChanges();
    }

    /**
     * Gets the active value for a filter
     */
    getValue(): DuplicatesStatusEnum {
        return this.value;
    }

    /**
     * Handles deleting a chip for the active value of this filter
     * @param chip A chip from this filter
     */
    removeChip(chip: ChipModel): void {
        this.setValue(DuplicatesStatusEnum.show);
    }

    /**
     * Resets the filter to not apply any changes
     */
    clear(): void {
        this.setValue(DuplicatesStatusEnum.show);
    }

    /**
     * Sets the current value for a filter
     * @param value
     */
    setCurrentValue(value: DuplicatesStatusEnum): void {
        this.currentValue = value;
        if (this.currentValue === DuplicatesStatusEnum.hide) {
            this.currentChips = [
                {
                    label: 'Common.filter.duplicates.hidden',
                    labelArgs: {
                        name: this.label
                    }
                }
            ];
        } else {
            this.currentChips = [];
        }
    }

    /**
     * Gets the current value for a filter
     */
    getCurrentValue(): DuplicatesStatusEnum {
        return this.currentValue;
    }

    /**
     * Handles deleting a chip for the current value of this filter
     * @param chip A chip from this filter
     */
    removeCurrentChip(chip: ChipModel): void {
        this.setCurrentValue(DuplicatesStatusEnum.show);
    }

    /**
     * Resets the current value to the active value
     */
    cancelChanges(): void {
        this.setCurrentValue(this.value);
    }
}
